<div class="card">
  <!-- <pre>{{empresa | json}}</pre> -->
  <!-- Cabeçalho -->
  <div class="header">
    <div class="avatar">
      <p-avatar
        *ngIf="!imageError && foto; else defaultAvatar"
        [image]="$any(foto)"
        shape="circle"
        size="large"
        (onImageError)="imageError = true"
      />
      <ng-template #defaultAvatar>
        <p-avatar
          [label]="getInitials(nome)"
          [icon]="!nome ? 'pi pi-building' : undefined"
          shape="circle"
          size="large"
        />
      </ng-template>
    </div>
    <div class="title">
      <h2>{{ nome || 'Empresa Desconhecida' }}</h2>
      <div class="info-empresa">
        <strong>{{ empresa?.tipoEmpresa }}</strong>
        <span>•</span>
        <p-tag *ngIf="activo == 'Activo'" severity="success" value="Activo"></p-tag>
        <p-tag *ngIf="activo != 'Activo'" severity="danger" value="Inactivo"></p-tag>
      </div>
    </div>
  </div>
  <div class="item-info">
    <div class="icon">
      <img src="icons/map-pin.svg" alt="Ícone de Website" />
    </div>
    <span>{{ endereco || 'Localização Desconhecida' }}</span>
  </div>

  <div class="item-info">
    <div class="icon">
      <img src="icons/building-05.svg" alt="Ícone de Localização" />
    </div>
    <span>{{ empresa?.subSector || 'Subsector Desconhecido' }}</span>
  </div>

  <div class="end-data">
    <div class="item-info">
      <div class="icon">
        <img src="icons/email.svg" alt="Ícone de Localização" />
      </div>
      <span>{{ empresa?.email || 'Sem Website' }}</span>
    </div>

    <div class="item-info">
      <div class="icon">
        <img src="icons/phone.svg" alt="Ícone de Localização" />
      </div>
      <span>{{ empresa?.telefone || 'Contato Desconhecido' }}</span>
    </div>
  </div>

  <!-- Navigation Icon -->
  <div class="navigate" (click)="ShowDetais($event)">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path
        d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
    </svg>
  </div>

  <div class="details-card" *ngIf="Show">
    <button type="button">Detalhes</button>
    <button type="button" (click)="AddRepresent($event)">Adicionar Representante</button>
  </div>
</div>